/* Julia and Bobbie — Theme JS */

(function () {
  // Mobile navigation toggle
  const toggle = document.querySelector('.site-nav__toggle');
  const mobileNav = document.querySelector('.site-nav--mobile');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open');
      toggle.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Close when a link is clicked
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
      });
    });
  }

  // Product image gallery (thumbnail switching)
  const thumbs = document.querySelectorAll('.product-detail__thumb');
  const mainImage = document.getElementById('ProductMainImage');

  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.dataset.image;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }
})();
